import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import TicketsScannerMemberInfo from './MemberInfo'
import TicketsScannerCrewMemberInfo from './CrewMemberInfo'
import TicketsScannerGuestInfo from './GuestInfo'
import { checkInTicket, removeCheckIn, resetAll } from '../../stores/ticketsScanner/actions'

const TicketsScannerTicketOwnerInfo = ({ ticket }) => {
  const checkInButtonRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    focusOnCheckIn()
  })

  const focusOnCheckIn = () => {
    if (checkInButtonRef.current) {
      checkInButtonRef.current.focus()
    }
  }

  const checkIn = () => {
    dispatch(checkInTicket(ticket))
  }

  const handleRemoveCheckIn = () => {
    dispatch(removeCheckIn(ticket))
  }

  const cancelCheckIn = () => {
    dispatch(resetAll())
  }

  const hasError = () => {
    if (!ticket.valid) {
      if (ticket.blacklisted) {
        return I18n.t("tickets_scanner.errors.ticket_blacklisted")
      } else if (!ticket.paid) {
        return I18n.t("tickets_scanner.errors.ticket_not_paid");
      } else {
        return I18n.t("tickets_scanner.errors.ticket_deleted")
      }
    }

    if (ticket.checked_in_at) {
      return I18n.t("tickets_scanner.errors.ticket_already_checked_in")
    }
  }

  let notice
  const errorMsg = hasError()

  if (errorMsg) {
    notice = (
      <div className="alert alert-danger">
        <i className="fa fa-warning fa-2x"></i>
        <span style={{ marginLeft: "10px" }}>{errorMsg}</span>
      </div>
    )
  }

  let info
  if (ticket.owner) {
    if (ticket.owner_type == "Member") {
      info = (
        <TicketsScannerMemberInfo
          member={ticket.owner}
          groupedTicketItems={ticket.ticket_items}
        />
      )
    } else if (ticket.owner_type == "CrewMember") {
      info = (
        <TicketsScannerCrewMemberInfo
          crew_member={ticket.owner}
          groupedTicketItems={ticket.ticket_items}
        />
      )
    } else {
      info = (
        <TicketsScannerGuestInfo
          guest={ticket.owner}
          groupedTicketItems={ticket.ticket_items}
        />
      )
    }
  }

  if (ticket.valid) {
    let checkInBtnClass = "btn btn-block "
    checkInBtnClass += hasError() ? "btn-warning" : "btn-primary"
    const checkInTitle = hasError()
      ? I18n.t("tickets_scanner.check_in_anyway")
      : I18n.t("tickets_scanner.check_in")

    const removeCheckInBtnClass = "btn btn-block btn-danger"
    const removeCheckInTitle = I18n.t("tickets_scanner.remove_check_in")

    return (
      <div className="ibox float-e-margins">
        <div className="ibox-content">
          {notice}
          {info}
        </div>
        <div className="ibox-footer">
          <div className="row">
            <div className="col-md-8">
              <button
                id="check-in"
                ref={checkInButtonRef}
                onClick={checkIn}
                className={checkInBtnClass}
              >
                {checkInTitle}
              </button>
            </div>
            {ticket.checked_in_at ? (
              <div className="col-md-2">
                <button
                  id="check-out"
                  onClick={handleRemoveCheckIn}
                  className={removeCheckInBtnClass}
                >
                  {removeCheckInTitle}
                </button>
              </div>
            ) : null}
            <div className="col-md-2">
              <button
                onClick={cancelCheckIn}
                className="btn btn-block btn-default"
              >
                {I18n.t("tickets_scanner.cancel_check_in")}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="ibox float-e-margins">
        <div className="ibox-content">
          {notice}
          {info}
        </div>
      </div>
    )
  }
}

export default TicketsScannerTicketOwnerInfo
